// src/components/CookiesBanner.jsx
import React, { useEffect, useState } from 'react';
import './CookiesBanner.css';

const CookiesBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const aceptadas = localStorage.getItem('cookies_aceptadas');
    if (!aceptadas) setVisible(true);
  }, []);

  const aceptar = () => {
    localStorage.setItem('cookies_aceptadas', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookies-banner">
      <p>
        Este sitio web utiliza cookies que permiten el funcionamiento y la prestación de los servicios
        ofrecidos en el mismo. Estas cookies no recogen ni almacenan sus datos personales.
      </p>
      <div className="cookies-buttons">
        <button onClick={aceptar}>Entendido</button>
        <a
          href="/uploads/cookies/politica_de_cookies.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Más información
        </a>
      </div>
    </div>
  );
};

export default CookiesBanner;
